import * as React from "react";
import i18n from "i18n";
import { Link, LinkContainer } from "components/common";
import ReportRoutes from "report/ReportRoutes";
import { Button } from "components/bootstrap";
import StatusCell from "report/report-history-page/StatusCell";
import { COLUMN_WIDTH } from "components/common/EntityDataTable/Constants";
const customColumnRenderers = (pluggableColumnRenderers) => ({
  attributes: {
    owner_full_name: {
      staticWidth: COLUMN_WIDTH.user
    },
    title: {
      renderCell: (title, report) => /* @__PURE__ */ React.createElement(Link, { to: ReportRoutes.archive(report.id) }, title)
    },
    subtitle: {
      staticWidth: COLUMN_WIDTH.title
    },
    status: {
      renderCell: (_, report) => report.status ? /* @__PURE__ */ React.createElement(StatusCell, { value: report.status }) : null,
      staticWidth: 140
    },
    recipients: {
      renderCell: (_, report) => /* @__PURE__ */ React.createElement(LinkContainer, { key: "configuration-button", to: ReportRoutes.EDIT.delivery(report.id) }, /* @__PURE__ */ React.createElement(Button, { bsSize: "xsmall" }, report.delivery.email_receivers.length + report.delivery.user_receivers.length === 0 ? i18n.t("column_renderers.add_emails", { ns: "enterprise_report" }) : report.delivery.email_receivers.length + report.delivery.user_receivers.length)),
      staticWidth: "matchHeader",
      textAlign: "right"
    },
    ...pluggableColumnRenderers || {}
  }
});
export default customColumnRenderers;
